<template>
  <div class="displayKeyValue">
    <label :class="[weight, 'has-text-weight-semibold']" :style="{ width: width }">{{label}}</label>
    <span class="word-break flex-center"><slot name="before" /><span>{{text}}</span></span>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    text: [String, Number],
    width: {
      type: String,
      default: "100px",
    },
    weight: {
      type: String,
      default: "label",
    },
  },
};
</script>


<style lang="scss" scoped>
.displayKeyValue {
  display: flex;
}
.label {
  text-align: right;
  padding-right: 12px;
}
.word-break {
  word-break: break-all;
  width: 70%;
}
</style>

